module.exports = __webpack_public_path__ + "img/mein_schwein_green@2x.b546dc77.png";